import React from 'react';
import messagesRelSituation from 'components/MyContractInfo/ReleveSituationinfo/messages';
import { Grid, Tooltip, Box } from '@material-ui/core';
import { get, isEmpty } from 'lodash';
import moment from 'moment';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import { useIntl } from 'react-intl';
import {
  StyledInfoIcon,
  StyledCaptions,
  StyledShortBody,
} from 'containers/EpargnDetailsPage/ReleveSituation/styles';
import { currencyFormat, renderUnit, renderUnitTaux } from 'utils/string';
import { _renderTypePrime } from 'utils/string';

const versementsPerYearEmptyData = [
  { CODE_PRODUIT: '', MONTANT_PRIMES: '', DATE_PRIME: '' },
];
const rachatsPerYearEmptyData = [
  { CODE_PRODUIT: '', RP_NET: '', DATE_RP: '', IR_RP: '', PENALITE_RP: '' },
];

export const RenderVersementsPerYearDetailsSM = ({
  versementsPerYear,
  formatMessage,
  reverse,
}: any) => (
  <>
    <Grid item xs={4}>
      <StyledCaptions>
        {formatMessage(get(messagesRelSituation, 'dateVersement'))}
      </StyledCaptions>
    </Grid>
    <Grid item xs={4} style={{ display: 'inline-flex' }}>
      <StyledCaptions>
        {formatMessage(get(messagesRelSituation, 'primeType'))}
      </StyledCaptions>
    </Grid>
    <Grid item xs={4}>
      <StyledCaptions>
        {formatMessage(get(messagesRelSituation, 'montantBrut'))}
      </StyledCaptions>
    </Grid>
    {(isEmpty(versementsPerYear)
      ? versementsPerYearEmptyData
      : versementsPerYear
    ).map(
      (item: {
        CODE_PRODUIT: number;
        MONTANT_PRIMES: number;
        DATE_PRIME: string;
      }) => (
        <>
          <Grid item xs={4}>
            <StyledShortBody reverse={reverse}>
              {get(item, 'DATE_PRIME')
                ? moment(get(item, 'DATE_PRIME'), 'YYYY-MM-DD')
                    .format('DD/MM/YYYY')
                    .toString()
                : '-'}
            </StyledShortBody>
          </Grid>
          <Grid item xs={4}>
            <StyledShortBody reverse={reverse}>
              {isEmpty(get(item, 'TYPE_PRIMES'))
                ? '-'
                : _renderTypePrime(get(item, 'TYPE_PRIMES', ''), useIntl)}
            </StyledShortBody>
          </Grid>
          <Grid item xs={4} dir="ltr">
            <StyledShortBody reverse={reverse}>
              {currencyFormat(get(item, 'MONTANT_PRIMES', 0)) +
                '' +
                renderUnit(get(item, 'MONTANT_PRIMES', 0), reverse)}
            </StyledShortBody>
          </Grid>
        </>
      ),
    )}
  </>
);

export const RenderVersementsPerYearDetailsXS = ({
  versementsPerYear,
  formatMessage,
  reverse,
}: any) => (
  <>
    {(isEmpty(versementsPerYear)
      ? versementsPerYearEmptyData
      : versementsPerYear
    ).map(
      (item: {
        CODE_PRODUIT: number;
        MONTANT_PRIMES: number;
        DATE_PRIME: string;
      }) => (
        <Grid
          container
          spacing={1}
          style={{
            backgroundColor: '#F2F2F2',
            margin: '4px 0',
            padding: '14px 12px',
            borderRadius: '8px',
          }}
        >
          <Grid item xs={6}>
            <StyledCaptions>
              {formatMessage(get(messagesRelSituation, 'dateVersement'))}
            </StyledCaptions>
          </Grid>
          <Grid item xs={6} style={{ display: 'inline-flex' }}>
            <StyledCaptions>
              {formatMessage(get(messagesRelSituation, 'primeType'))}
            </StyledCaptions>
          </Grid>
          <Grid item xs={6}>
            <StyledShortBody>
              {isEmpty(get(item, 'DATE_PRIME'))
                ? '-'
                : moment(get(item, 'DATE_PRIME'), 'YYYY-MM-DD')
                    .format('DD/MM/YYYY')
                    .toString()}
            </StyledShortBody>
          </Grid>
          <Grid item xs={6}>
            <StyledShortBody>
              {_renderTypePrime(get(item, 'TYPE_PRIMES', '-'), useIntl)}
            </StyledShortBody>
          </Grid>
          <Grid
            container
            xs={12}
            style={{ marginTop: '8px', marginBottom: '4px' }}
          >
            <Grid item xs={6}>
              <StyledCaptions>
                {formatMessage(get(messagesRelSituation, 'montantBrut'))}
              </StyledCaptions>
            </Grid>
          </Grid>
          <Grid container xs={12}>
            <Grid item xs={6} dir="ltr">
              <StyledShortBody reverse={reverse}>
                {currencyFormat(get(item, 'MONTANT_PRIMES', 0)) +
                  '' +
                  renderUnit(get(item, 'MONTANT_PRIMES', 0), reverse)}
              </StyledShortBody>
            </Grid>
          </Grid>
        </Grid>
      ),
    )}
  </>
);

export const RenderRachatsPerYearDetailsSM = ({
  rachatsPerYear,
  formatMessage,
  reverse,
}: any) => (
  <>
    <Grid item xs={3} style={{ display: 'inline-flex' }}>
      <StyledCaptions>
        {formatMessage(get(messagesRelSituation, 'rachatDate'))}
      </StyledCaptions>
    </Grid>
    <Grid item xs={3} style={{ display: 'inline-flex' }}>
      <StyledCaptions>
        {formatMessage(get(messagesRelSituation, 'irRachat'))}
      </StyledCaptions>
      <Tooltip
        title={formatMessage(get(messagesRelSituation, 'irRachatTooltip'))}
      >
        <StyledInfoIcon fontSize={'small'} />
      </Tooltip>
    </Grid>
    <Grid item xs={3} style={{ display: 'inline-flex' }}>
      <StyledCaptions>
        {formatMessage(get(messagesRelSituation, 'penaliteRachat'))}
      </StyledCaptions>
      <Tooltip
        title={formatMessage(
          get(messagesRelSituation, 'penaliteRachatTooltip'),
        )}
      >
        <StyledInfoIcon fontSize={'small'} />
      </Tooltip>
    </Grid>
    <Grid item xs={3} style={{ display: 'inline-flex' }}>
      <StyledCaptions>
        {formatMessage(get(messagesRelSituation, 'rachatPartielNet'))}
      </StyledCaptions>
      <Tooltip
        title={formatMessage(
          get(messagesRelSituation, 'rachatPartielNetTooltip'),
        )}
      >
        <StyledInfoIcon fontSize={'small'} />
      </Tooltip>
    </Grid>

    {(isEmpty(rachatsPerYear) ? rachatsPerYearEmptyData : rachatsPerYear).map(
      (item: {
        CODE_PRODUIT: number;
        RP_NET: number;
        DATE_RP: string;
        IR_RP: number;
        PENALITE_RP: number;
      }) => (
        <>
          <Grid item xs={3}>
            <StyledShortBody>
              {isEmpty(get(item, 'DATE_RP'))
                ? '-'
                : moment(get(item, 'DATE_RP'), 'YYYY-MM-DD')
                    .format('DD/MM/YYYY')
                    .toString()}
            </StyledShortBody>
          </Grid>
          <Grid item xs={3} dir="ltr">
            <StyledShortBody reverse={reverse}>
              {currencyFormat(get(item, 'IR_RP', 0)) +
                '' +
                renderUnit(get(item, 'IR_RP', 0), reverse)}
            </StyledShortBody>
          </Grid>
          <Grid item xs={3} dir="ltr">
            <StyledShortBody reverse={reverse}>
              {currencyFormat(get(item, 'PENALITE_RP', 0)) +
                '' +
                renderUnit(get(item, 'PENALITE_RP', 0), reverse)}
            </StyledShortBody>
          </Grid>
          <Grid item xs={3} dir="ltr">
            <StyledShortBody reverse={reverse}>
              {currencyFormat(get(item, 'RP_NET', 0)) +
                '' +
                renderUnit(get(item, 'RP_NET', 0), reverse)}
            </StyledShortBody>
          </Grid>
        </>
      ),
    )}
  </>
);

export const RenderRachatsPerYearDetailsXS = ({
  rachatsPerYear,
  formatMessage,
  reverse,
  handleOpenTooltipDialog,
}: any) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  return (
    <>
      {(isEmpty(rachatsPerYear) ? rachatsPerYearEmptyData : rachatsPerYear).map(
        (item: {
          CODE_PRODUIT: number;
          RP_NET: number;
          DATE_RP: string;
          IR_RP: number;
          PENALITE_RP: number;
        }) => (
          <Grid
            container
            spacing={1}
            style={{
              backgroundColor: '#F2F2F2',
              margin: '4px 0',
              padding: '14px 12px',
              borderRadius: '8px',
            }}
          >
            <Grid item xs={6} style={{ display: 'inline-flex' }}>
              <StyledCaptions>
                {formatMessage(get(messagesRelSituation, 'rachatDate'))}
              </StyledCaptions>
            </Grid>
            <Grid item xs={6} style={{ display: 'inline-flex' }}>
              <StyledCaptions>
                {formatMessage(get(messagesRelSituation, 'irRachat'))}
              </StyledCaptions>
              <Tooltip
                title={
                  matches
                    ? ''
                    : formatMessage(
                        get(messagesRelSituation, 'irRachatTooltip'),
                      )
                }
                onClick={handleOpenTooltipDialog(
                  formatMessage(get(messagesRelSituation, 'irRachat')),
                  formatMessage(get(messagesRelSituation, 'irRachatTooltip')),
                )}
              >
                <StyledInfoIcon fontSize={'small'} />
              </Tooltip>
            </Grid>
            <Grid item xs={6}>
              <StyledShortBody reverse={reverse}>
                {isEmpty(get(item, 'DATE_RP'))
                  ? '-'
                  : moment(get(item, 'DATE_RP'), 'YYYY-MM-DD')
                      .format('DD/MM/YYYY')
                      .toString()}
              </StyledShortBody>
            </Grid>
            <Grid item xs={6} dir="ltr">
              <StyledShortBody reverse={reverse}>
                {currencyFormat(get(item, 'IR_RP', 0)) +
                  '' +
                  renderUnit(get(item, 'IR_RP', 0), reverse)}
              </StyledShortBody>
            </Grid>
            <Grid
              item
              xs={6}
              style={{ display: 'inline-flex', marginTop: '8px' }}
            >
              <StyledCaptions>
                {formatMessage(get(messagesRelSituation, 'penaliteRachat'))}
              </StyledCaptions>
              <Tooltip
                title={
                  matches
                    ? ''
                    : formatMessage(
                        get(messagesRelSituation, 'penaliteRachatTooltip'),
                      )
                }
                onClick={handleOpenTooltipDialog(
                  formatMessage(get(messagesRelSituation, 'penaliteRachat')),
                  formatMessage(
                    get(messagesRelSituation, 'penaliteRachatTooltip'),
                  ),
                )}
              >
                <StyledInfoIcon fontSize={'small'} />
              </Tooltip>
            </Grid>
            <Grid
              item
              xs={6}
              style={{ display: 'inline-flex', marginTop: '8px' }}
            >
              <StyledCaptions>
                {formatMessage(get(messagesRelSituation, 'rachatPartielNet'))}
              </StyledCaptions>
              <Tooltip
                title={
                  matches
                    ? ''
                    : formatMessage(
                        get(messagesRelSituation, 'rachatPartielNetTooltip'),
                      )
                }
                onClick={handleOpenTooltipDialog(
                  formatMessage(get(messagesRelSituation, 'rachatPartielNet')),
                  formatMessage(
                    get(messagesRelSituation, 'rachatPartielNetTooltip'),
                  ),
                )}
              >
                <StyledInfoIcon fontSize={'small'} />
              </Tooltip>
            </Grid>
            <Grid item xs={6} dir="ltr">
              <StyledShortBody reverse={reverse}>
                {(isEmpty(get(item, 'PENALITE_RP'))
                  ? '-'
                  : get(item, 'PENALITE_RP', 0)) +
                  '' +
                  renderUnitTaux(get(item, 'PENALITE_RP', 0))}
              </StyledShortBody>
            </Grid>
            <Grid item xs={6} dir="ltr">
              <StyledShortBody reverse={reverse}>
                {currencyFormat(get(item, 'RP_NET', 0)) +
                  '' +
                  renderUnit(get(item, 'RP_NET', 0), reverse)}
              </StyledShortBody>
            </Grid>
          </Grid>
        ),
      )}
    </>
  );
};

export const RenderAvancesPerYearDetailsSM = ({
  avancesPerYear,
  formatMessage,
  reverse,
}: any) => (
  <>
    <Grid item xs={2}>
      <StyledCaptions>
        {formatMessage(get(messagesRelSituation, 'dateOctroi'))}
      </StyledCaptions>
    </Grid>
    <Grid item xs={2}>
      <Box paddingRight={2}>
        <StyledCaptions>
          {formatMessage(get(messagesRelSituation, 'montantAvance'))}
        </StyledCaptions>
      </Box>
    </Grid>
    <Grid item xs={2}>
      <StyledCaptions>
        {formatMessage(get(messagesRelSituation, 'tauxRenumeration'))}
      </StyledCaptions>
    </Grid>
    <Grid item xs={3}>
      <StyledCaptions>
        {formatMessage(get(messagesRelSituation, 'dateEcheanceRemboursement'))}
      </StyledCaptions>
    </Grid>
    <Grid item xs={3}>
      <StyledCaptions>
        {formatMessage(get(messagesRelSituation, 'montantAvanceNonRembourse'))}
      </StyledCaptions>
    </Grid>
    {avancesPerYear && (
      <>
        <Grid item xs={2}>
          <StyledShortBody reverse={reverse}>
            {get(avancesPerYear, 'DATE_DEBUT_AVC')
              ? moment(get(avancesPerYear, 'DATE_DEBUT_AVC'), 'YYYY-MM-DD')
                  .format('DD/MM/YYYY')
                  .toString()
              : '-'}
          </StyledShortBody>
        </Grid>
        <Grid item xs={2} dir="ltr">
          <StyledShortBody reverse={reverse}>
            {currencyFormat(get(avancesPerYear, 'MONTANT_AVC', 0)) +
              '' +
              renderUnit(get(avancesPerYear, 'MONTANT_AVC', 0), reverse)}
          </StyledShortBody>
        </Grid>
        <Grid item xs={2} dir="ltr">
          <StyledShortBody reverse={reverse}>
            {get(avancesPerYear, 'TAUX_INTERET_AVC', 0) +
              '' +
              renderUnitTaux(get(avancesPerYear, 'TAUX_INTERET_AVC', 0))}
          </StyledShortBody>
        </Grid>
        <Grid item xs={3}>
          <StyledShortBody reverse={reverse}>
            {get(avancesPerYear, 'DATE_FIN_AVC')
              ? moment(get(avancesPerYear, 'DATE_FIN_AVC'), 'YYYY-MM-DD')
                  .format('DD/MM/YYYY')
                  .toString()
              : '-'}
          </StyledShortBody>
        </Grid>
        <Grid item xs={3} dir="ltr">
          <StyledShortBody reverse={reverse}>
            {currencyFormat(
              get(avancesPerYear, 'MONTANT_AVC_NON_REMBOURSE', 0),
            ) +
              '' +
              renderUnit(
                get(avancesPerYear, 'MONTANT_AVC_NON_REMBOURSE', 0),
                reverse,
              )}
          </StyledShortBody>
        </Grid>
      </>
    )}
  </>
);

export const RenderAvancesPerYearDetailsXS = ({
  avancesPerYear,
  formatMessage,
  reverse,
}: any) => (
  <>
    {avancesPerYear && (
      <Grid
        container
        spacing={1}
        style={{
          backgroundColor: '#F2F2F2',
          margin: '4px 0',
          padding: '14px 12px',
          borderRadius: '8px',
        }}
      >
        <Grid item xs={6}>
          <StyledCaptions>
            {formatMessage(get(messagesRelSituation, 'dateOctroi'))}
          </StyledCaptions>
        </Grid>
        <Grid item xs={6}>
          <Box paddingRight={2}>
            <StyledCaptions>
              {formatMessage(get(messagesRelSituation, 'montantAvance'))}
            </StyledCaptions>
          </Box>
        </Grid>
        <Grid item xs={6} dir="ltr">
          <StyledShortBody reverse={reverse}>
            {get(avancesPerYear, 'DATE_DEBUT_AVC')
              ? moment(get(avancesPerYear, 'DATE_DEBUT_AVC'), 'YYYY-MM-DD')
                  .format('DD/MM/YYYY')
                  .toString()
              : '-'}
          </StyledShortBody>
        </Grid>
        <Grid item xs={6} dir="ltr">
          <StyledShortBody reverse={reverse}>
            {get(avancesPerYear, 'TAUX_INTERET_AVC', '')}
          </StyledShortBody>
        </Grid>

        <Grid item xs={6} style={{ marginTop: '8px' }}>
          <StyledCaptions>
            {formatMessage(get(messagesRelSituation, 'tauxRenumeration'))}
          </StyledCaptions>
        </Grid>
        <Grid item xs={6} style={{ marginTop: '8px' }}>
          <StyledCaptions>
            {formatMessage(
              get(messagesRelSituation, 'dateEcheanceRemboursement'),
            )}
          </StyledCaptions>
        </Grid>
        <Grid item xs={6} dir="ltr">
          <StyledShortBody reverse={reverse}>
            {get(avancesPerYear, 'TAUX_INTERET_AVC', 0) +
              '' +
              renderUnitTaux(get(avancesPerYear, 'TAUX_INTERET_AVC', 0))}
          </StyledShortBody>
        </Grid>
        <Grid item xs={6}>
          <StyledShortBody reverse={reverse}>
            {get(avancesPerYear, 'DATE_FIN_AVC')
              ? moment(get(avancesPerYear, 'DATE_FIN_AVC'), 'YYYY-MM-DD')
                  .format('DD/MM/YYYY')
                  .toString()
              : '-'}
          </StyledShortBody>
        </Grid>

        <Grid
          container
          xs={12}
          style={{ marginTop: '8px', marginBottom: '4px' }}
        >
          <Grid item xs={6}>
            <StyledCaptions>
              {formatMessage(
                get(messagesRelSituation, 'montantAvanceNonRembourse'),
              )}
            </StyledCaptions>
          </Grid>
        </Grid>
        <Grid container xs={12}>
          <Grid item xs={6} dir="ltr">
            <StyledShortBody reverse={reverse}>
              {get(avancesPerYear, 'MONTANT_AVC_NON_REMBOURSE', '')}
            </StyledShortBody>
          </Grid>
        </Grid>
      </Grid>
    )}
  </>
);
